import { verifyTokenApi } from "@/api/services/admin/auth";
import { LoadingScreen } from "@/components/elements/Loading/Loading";
import { LoginLogo } from "@/features/auth/components/LoginLogo";
import { RegisterForm } from "@/features/auth/components/RegisterForm";
import { TRegisterQueryParam } from "@/features/auth/types/registerQueryParam";
import { AppRoutes } from "@/routes/config";
import { getQueryFromURL } from "@/utils/url";
import { Stack } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

type TRegisterPageProps = {};

export const RegisterPage: FC<TRegisterPageProps> = () => {
  const query = getQueryFromURL<TRegisterQueryParam>();
  const navigate = useNavigate();
  const [isVerifying, setIsVerifying] = useState(true);
  const [isTokenValid, setIsTokenValid] = useState(false);

  useEffect(() => {
    const verifyToken = async () => {
      if (!query || !query.email || !query.resetToken) {
        navigate(AppRoutes.login);
        return;
      }

      try {
        await verifyTokenApi(query.resetToken);
        setIsTokenValid(true);
      } catch {
        navigate(AppRoutes.pageNotFound);
      } finally {
        setIsVerifying(false);
      }
    };

    verifyToken();
  }, []);

  if (isVerifying) {
    return <LoadingScreen />;
  }

  if (!isTokenValid) {
    return null;
  }

  return (
    <Stack gap={6} alignItems="center">
      <LoginLogo />
      <RegisterForm />
    </Stack>
  );
};
